export type AssetAccessSource = {
  sourceIdentifier?: string;
  sourceName?: string;
  accessRequirement?: string;
  accessibleWhilePlantRunning?: string;
};

export type ProjectAccessRequirement = {
  id: string;
  assetId: string;
  assetName: string;
  requirement: string;
  plantRunningAccess: string;
};

function clean(value: string | undefined) {
  return typeof value === "string" ? value.trim() : "";
}

export function extractProjectAccessRequirements(assets: AssetAccessSource[]): ProjectAccessRequirement[] {
  return assets.flatMap((asset, index) => {
    const requirement = clean(asset.accessRequirement);
    const plantRunningAccess = clean(asset.accessibleWhilePlantRunning);
    if (!requirement && !plantRunningAccess) return [];
    const assetId = clean(asset.sourceIdentifier) || `Asset ${index + 1}`;
    return [{ id: `access-${index + 1}-${assetId.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`, assetId, assetName: clean(asset.sourceName) || "Unnamed asset", requirement, plantRunningAccess }];
  });
}

export function accessReviewReady(requirements: ProjectAccessRequirement[], acknowledged: boolean) {
  return acknowledged && requirements.every((item) => item.requirement.trim().length > 0);
}

export function uniqueAccessNotes(requirements: ProjectAccessRequirement[]) {
  return [...new Set(requirements.map((item) => item.requirement.trim()).filter(Boolean))];
}
